<div class="dialog-wrapper">
    <h2 >{{ "project-settings.error.unauthorized.title" | translate }}</h2>
    <h2>{{ "project-settings.error.unauthorized.subtitle" | translate }}</h2>
    <div class="window-button-container button-container-margin">
        <button class="window-button component-large button-stay-color" (click)="onNoClick()">{{ "project-settings.error.unauthorized.cancel" | translate }}</button>
        <button class="window-button component-large button-leave-color" (click)="onContinue()">{{ "project-settings.error.unauthorized.continue" | translate }}</button>
    </div>
</div>